// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".virtual-scroll[data-v-23a2f2b1]{display:flex;width:100%;height:100%}.virtual-scroll__scroller[data-v-23a2f2b1]{width:100%}.virtual-scroll[data-v-23a2f2b1] .vue-recycle-scroller__item-wrapper{height:100%;min-height:100%!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
